<template>
  <div id="index">
    <div v-if="idloading">
      <div class="spinner-box">
        <img src="@/assets/img/loadding_pc.gif" alt="">
        <div>努力加载中...</div>
      </div>
    </div>
    <div v-else class="visible-xs min_index">
      <!-- 头部 -->
      <MinHeader :searchText="searchText" ref="header" @searchFun="searchFun"></MinHeader>
      <!-- <Hezuo></Hezuo> -->

      <!-- 导航 -->
      <div class="head_top flex_between">
        <div class="head_left">
          <div class="head_ul">
            <div class="head_li flex_center" v-for="(liem, index) in recommended_arr.length>8?recommended_arr.slice(0,8):recommended_arr" :class="{ selected: recommended_id == liem.conf_id }" @click.stop="recommendedFun(index)" :key="index">
              {{ liem.title }}
            </div>
            <div class="head_li flex_center" @click="is_menu = true">
              更多
            </div>
          </div>
        </div>
        <i class="head_right" @click="is_menu = true"><img src="@/assets/img/menu_icon.png" alt="" /></i>
      </div>
      <div class="">
        <div style="height:100px;width:100%"></div>
        <div class="list_head flex_between">
          <span class="list_title">{{
            recommended_arr[recommended_index].title
          }}</span>

          <el-button class="focus_button cancel" @click="follow(2)" v-if="recommended_arr[recommended_index].is_follow == 1&&recommended_arr[recommended_index].conf_id!=0" size="mini" type="info">取消关注
          </el-button>
          <el-button class="focus_button" @click="follow(1)" v-if="recommended_arr[recommended_index].is_follow == 0&&recommended_arr[recommended_index].conf_id!=0" size="mini" type="danger">关注栏目</el-button>
        </div>
        <MListLi v-if="list_arr.length > 0" :list_arr="list_arr" ref="listLi" @detailsFun="detailsFun"></MListLi>
        <div class="complete" v-else-if="is_request">
          <div class="claloadding">
            <div>
              <img src="@/assets/img/kkry_pc.gif" alt="">
            </div>
            <div>空空如也...</div>
          </div>
        </div>
        <div class="complete" v-else>
          <div class="claloadding">
            <img src="@/assets/img/loadding_pc.gif" alt="">
            <div>努力加载中...</div>
          </div>

        </div>
      </div>
      <!-- 菜单弹窗 -->
      <div class="menu_popup" v-if="is_menu">
        <i class="popup_esc" @click="is_menu = false">
          <img src="@/assets/img/cha.png" alt="" />
        </i>
        <div class="menu_div">
          <div class="head_li flex_center" v-for="(liem, index) in recommended_arr" :key="index" :class="{ selected: recommended_id == liem.conf_id }" @click.stop="recommendedFun(index, 2)">
            {{ liem.title }}
          </div>
        </div>
      </div>
      <!-- 提示注册弹窗 -->
      <LoginPrompt @promptFun="promptFun" ref="prompt"></LoginPrompt>

    </div>
    <!-- 尾部 -->
    <MinFooter :headIndex="2"></MinFooter>
  </div>
</template>

<script>
import MinHeader from "@/components/m_assembly/MinHeader.vue"; //头部模块
import MinFooter from "@/components/m_assembly/MinFooter.vue"; //尾部模块
import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //注册弹窗模块
import MListLi from "@/components/assembly/m_listLi.vue"; //列表数据模块
import Hezuo from '@/components/tool/m_hezuo.vue'

import "@/assets/js/swiper.animate1.0.3.min.js";
import "@/assets/css/animate.min.css";
import "@/assets/css/video-js.min.css";

export default {
  name: "m_column",
  data() {
    return {
      is_menu: false, //是否菜单列表
      user: {}, //用户信息
      recommended_index: -1, //导航 index
      recommended_id: 0, //导航 index
      recommended_arr: [], //导航列表
      page: 1,
      list_arr: [],
      searchText: "", //搜索内容
      is_request: false,
      idloading: true
    };
  },
  computed: {
    MembershipType: function () {
      return this.MembershipGrade(this.user.plus);
    },
  },
  components: {
    MinHeader,
    MinFooter,
    LoginPrompt,
    MListLi,
    Hezuo
  },
  watch: {
    recommended_index: function (eve) {
      this.$store.commit("setColumn", eve);
      this.is_menu = false;
      this.page = 1;
      this.list_arr = [];
      this.getList();
    },
  },
  methods: {
    judgeUser() {
      //判断用户数据
      if (this.USER() && this.USER() !== {}) {
        this.REFRESH_USER();
      } else {
        this.$refs.prompt.popupFun();
      }
    },
    recommendedFun(index, type) {
      //切换导航
      this.recommended_id = this.recommended_arr[index].conf_id;
      this.recommended_index = index;
      if (type == 2) {
        setTimeout(() => {
          $(".head_left").scrollLeft($(".selected").offset().left);
        }, 500);
      }
    },
    follow(type) {
      //1关注2取关
      let that = this;
      this.judgeUser();
      this.$post("follow", {
        conf_id: this.recommended_id,
        member_id: this.USER().id,
        type: type,
      }).then((res) => {
        that.recommended_arr[that.recommended_index].is_follow =
          that.recommended_arr[that.recommended_index].is_follow == 1 ? 0 : 1;
      });
    },
    searchFun(text) {
      this.searchText = text;
      this.page = 1;
      this.getList();
    },
    detailsFun(id) {
      //查看详情
      this.$router.push({
        path: "/m_column_details",
        query: { id: id, head_index: 2 },
      });
    },
    promptFun() {
      //提示弹窗回调
      this.$router.replace("/m_registered");
    },
    getUser() {
      let that = this;
      this.REFRESH_USER();
      that.user = that.USER();
    },
    getList() {
      //获取列表数据
      let that = this;
      this.is_request = false;
      if (this.page == 1) {
        this.list_arr = [];
      }
      this.$post("news_lists", {
        conf_id: this.recommended_id,
        limit: 10,
        page: this.page,
        keyword: this.searchText,
      }).then((res) => {
        that.is_request = true;
        that.list_arr = that.list_arr.concat(res.data.data);
        that.$nextTick(() => {
          that.$refs.listLi.videoFun();
        });
      });
    },
    getNews() {
      //获取栏目
      let that = this;
      if (this.$route.query.id) {
        this.recommended_id = this.$route.query.id;
      }
      this.$get("news_conf", {
        page: 1,
        limit: 999,
        member_id: this.USER().id,
      }).then((res) => {
        that.recommended_arr = res.data.data;
        that.recommended_id = that.recommended_id
          ? that.recommended_id
          : that.recommended_arr[0].conf_id;
        that.recommended_arr.forEach((liem, index) => {
          if (that.recommended_id == liem.conf_id) {
            that.recommended_index = index;
            setTimeout(() => {
              let left = $(".selected").offset().left - $(window).width() / 2;
              $(".head_left").animate({ scrollLeft: left }, 100);
            }, 500);
          }
        });
      });
    },
  },
  activated() {

  },
  beforeRouteEnter(to, from, next) {
    // ifroute
    next(vm => {
      if (from.name === 'm_column_details') {

      } else {

        document.body.scrollTop = document.documentElement.scrollTop = 0;
        vm.idloading = false
        let that = vm;
        if (vm.USER() && vm.USER() !== {}) {
          vm.REFRESH_USER();
        }
        if (vm.$route.query.searchText) {
          vm.searchText = vm.$route.query.searchText;
          setTimeout(() => {
            that.$refs.header.headerFun(vm.searchText);
          }, 500);
        }
        vm.recommended_id = 0
        vm.recommended_index = 0
        if (vm.$route.query.id) {
          vm.getNews();
        }
        vm.list_arr = [];
        vm.page = 0;
        // vm.getNews();
        vm.getList()
        vm.getShare();
        vm.getUser();
      }
    })
  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.idloading = false
    let that = this;
    if (this.USER() && this.USER() !== {}) {
      this.REFRESH_USER();
    }
    if (this.$route.query.searchText) {
      this.searchText = this.$route.query.searchText;
      setTimeout(() => {
        that.$refs.header.headerFun(this.searchText);
      }, 500);
    }
    this.recommended_id = this.$store.state.column_id;
    document.title = "麻醉眼界";
    this.list_arr = [];
    this.getNews();
    this.getShare();
    this.getUser();
    if (this._isMobile()) {
    } else {
      // alert("pc端");
      this.$router.replace("/");
    }

    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var scrollHeight = $(document).height();
      var windowHeight = $(this).height();
      if (scrollTop + windowHeight + 2 >= scrollHeight) {
        that.page++;
        that.getList();
      }
    });
  },
};
</script>

<style scoped>
html,
body {
  max-width: 100vw;
}

#index {
  /* padding-top: 90px; */
}

header.header {
  box-shadow: 0 !important;
}

.visible-xs {
  width: 100vw;
  overflow: hidden;
  padding-top: 0rem !important;
}

/* 导航 */
.min_index > .head_top {
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  padding: 0 1.6rem;
  background: #fff;
  box-shadow: 0 5px 9px rgba(71, 71, 71, 0.11);
  z-index: 998;
  overflow-x: auto;
  white-space: nowrap;
}
.claloadding {
  width: 100%;
  height: 50vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
.head_top .head_left {
  flex: 1;
  overflow: hidden;
  overflow-x: auto;
}

.head_top .head_right {
  width: 2rem;
  margin-left: 1rem;
}

.head_top .head_li {
  height: 3.8rem;
  display: inline-flex;
  position: relative;
  font-size: 1.4rem;
  margin-right: 2rem;
  color: #999;
  border-bottom: 0.15rem solid #fff;
}

.head_top .head_li.selected {
  color: #333;
  font-weight: bold;
  border-color: #f04c61;
}

/* 菜单弹出 */
.menu_popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f9fbfe;
  z-index: 999;
}

.menu_popup .popup_esc {
  width: 1.5rem;
  height: 1.5rem;
  position: absolute;
  top: 1.6rem;
  left: 1.6rem;
}

.menu_popup .menu_div {
  margin-top: 6rem;
  padding: 0 1rem 6rem 1rem;
  height: calc(100vh - 6rem);
  overflow-y: auto;
}

.menu_popup .menu_div .head_li {
  min-width: calc(25% - 1rem);
  height: 3rem;
  padding: 0 1rem;
  border-radius: 0.5rem;
  background: #dfdfdf;
  color: #666666;
  font-size: 1.4rem;
  margin: 0.5rem;
  display: inline-flex;
}

.menu_popup .menu_div .head_li.selected {
  background: #f24d5b;
  color: #fff;
}

.list_head {
  padding: 1rem 2rem 1rem 2rem;
  border-bottom: 0.05rem solid #f1f1f1;
}

.list_head .list_title {
  font-size: 2rem;
  color: #333;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_column.vue